module.exports = __webpack_public_path__ + "assets/img/66_525_2.6cc4ccd9.jpg";